import React from 'react';
import { Routes, Route } from "react-router-dom";

import AdvancedPlayerPermalink from '../component/smart/permalinks/AdvancedPlayerPermalink';

export default (
	<Routes>
		<Route path="/player/permalink/:permalinkID" element={<AdvancedPlayerPermalink />} />
		<Route path="/event/permalink/:eventHash" element={<AdvancedPlayerPermalink />} />
	</Routes>
)
